import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import FormTextField from "components/form/form-textfield";
import { validatePosition, getDragValues, getEndValue, isOverlapped, MIN_DURATION } from "./timeline-utils";
import DataGrid, { DataGridItem } from "components/data-grid";
import { DebouncingInputsProvider } from "components/form";

const TimelineSegmentInputs = ({
  segment: currentSegment,
  period,
  disabled = false,
  onChange,
  intl,
  classes,
  element,
}) => {
  const handleEndOnBlur = type => val => {
    const value = validatePosition({
      val: parseInt(val, 10) || 0,
      min: 0,
      max: period,
    });

    const end = validatePosition({
      val: value,
      min: currentSegment.start + MIN_DURATION,
      max: period,
    });

    if (!isOverlapped({ id: currentSegment.id, start: currentSegment.start, end, segments: element.segments })) {
      onChange({
        ...currentSegment,
        end,
      });
    }
  };

  const handleEndChange = name => val => {
    const end = getEndValue({
      value: parseInt(val) || 0,
      period,
    });

    if (!isOverlapped({ id: currentSegment.id, start: currentSegment.start, end, segments: element.segments })) {
      onChange({
        ...currentSegment,
        end,
      });
    }
  };

  const handleStartChange = name => val => {
    const duration = currentSegment.end - currentSegment.start;
    const { start, end } = getDragValues({
      value: parseInt(val) || 0,
      period,
      duration,
    });

    if (!isOverlapped({ id: currentSegment.id, start, end, segments: element.segments })) {
      onChange({
        ...currentSegment,
        start,
        end,
      });
    }
  };

  return (
    <DebouncingInputsProvider disabled>
      <DataGridItem big style={{ padding: 12 }}>
        <DataGrid>
          <DataGridItem style={{ padding: "0px 12px" }}>
            <FormTextField
              disabled={disabled}
              type="number"
              name="start"
              inputProps={{ min: 0 }}
              value={currentSegment.start}
              onChange={handleStartChange}
              onFocus={e => e.target.select()}
              label={intl.formatMessage({ id: "timeline.element.start" })}
            />
          </DataGridItem>
          <DataGridItem style={{ padding: "0px 12px" }}>
            <FormTextField
              disabled={disabled}
              type="number"
              name="end"
              inputProps={{ min: 0 }}
              value={currentSegment.end}
              onChange={handleEndChange}
              onBlur={e => handleEndOnBlur(e.target.value)}
              onFocus={e => e.target.select()}
              label={intl.formatMessage({ id: "timeline.element.end" })}
            />
          </DataGridItem>
        </DataGrid>
      </DataGridItem>
    </DebouncingInputsProvider>
  );
};

TimelineSegmentInputs.propTypes = {
  /*
   * Elemento a representar en el timeline
   */
  element: PropTypes.shape({
    layoutId: PropTypes.string.isRequired,
    showAlways: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    segments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        start: PropTypes.number,
        end: PropTypes.number,
      }),
    ),
  }),
  /*
   * Segmento a representar en el componente
   */
  segment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    start: PropTypes.number,
    end: PropTypes.number,
  }),
  /*
   * Indica si está deshabilitado
   */
  disabled: PropTypes.bool,
  /*
   * Callback que se llama con el elemento actualizado
   */
  onChange: PropTypes.func,
  /*
   * Período que representa el timeline (en segundos)
   */
  period: PropTypes.number,
};

export default injectIntl(TimelineSegmentInputs);
